const SET_MOBILE = 'SET_MOBILE';
const UPDATE_FILTER = 'UPDATE_FILTER';
const UPDATE_FILTER_DATE = 'UPDATE_FILTER_DATE';
const TOGGLE_FILTER_CONFIDENCE = 'TOGGLE_FILTER_CONFIDENCE';
const RESET_FILTER = 'RESET_FILTER';
const UPDATE_ALL_NEIGHBORHOODS = 'UPDATE_ALL_NEIGHBORHOODS';
const UPDATE_MOBILE_RESOURCE_EXPANDS = 'UPDATE_MOBILE_RESOURCE_EXPANDS';
export {SET_MOBILE, UPDATE_FILTER, RESET_FILTER, UPDATE_FILTER_DATE, TOGGLE_FILTER_CONFIDENCE, UPDATE_ALL_NEIGHBORHOODS, UPDATE_MOBILE_RESOURCE_EXPANDS}
